import { Injectable } from '@angular/core';
// import { Product } from './shared/product.model';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Common, Guid } from '../model/common.model';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
// import { PARAMETERS } from '@angular/core/src/util/decorators';


@Injectable()
export class CartService {

  pageno: any;
  pagesize: any;
  stype: any;
  itemname: any;
  backflag: any = '0';
  Position: any;
  products: any[] = []
  cartTotal: number = 0;
  private customer = new Subject<any>();
  private productAddedSource = new Subject<any>();
  private productAddedSource1 = new Subject<any>();
  private productUpdatedSource = new Subject<any>();
  private productUpdatedLoginSource = new Subject<any>();
  private southernPunchOutSource = new Subject<any>();
  southernAdded$ = this.southernPunchOutSource.asObservable();
  customeradded$ = this.customer.asObservable();
  productAdded$ = this.productAddedSource.asObservable();
  productAdded1$ = this.productAddedSource1.asObservable()
  productUpdated$ = this.productUpdatedSource.asObservable();
  productUpdatedLogin$ = this.productUpdatedLoginSource.asObservable();


  constructor(private readonly http: HttpClient, private readonly dataService: DataService) {
    // Common = new Common();
    // this.cookname = Common.cookname;
    this.pageno = undefined;


  }


  setpageno(pageno) {

    this.pageno = pageno;
  }
  getpageno() {

    return this.pageno;
  }
  setbackflag(backflag) {

    this.backflag = backflag;
  }
  getbackflag() {
    return this.backflag;
  }
  setitemname(item) {

    this.itemname = item;

  }
  getitemname() {

    return this.itemname;
  }

  setpagesizeno(pagesize) {
    this.pagesize = pagesize;

  }
  getpagesizeno() {

    return this.pagesize;
  }

  setstype(stype) {
    this.stype = stype;

  }
  getstype() {

    return this.stype;
  }
  setPosition(Position) {
    this.Position = Position;
  }
  getPosition() {
    return this.Position;
  }

  addProductToCart(product, sum) {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }
    if (product.list_price > 0) {

    }
    else {
      product.list_price = 0;
    }
    var cartModel = {
      "itemnumber": product.itemname,
      "Quantity": product.quantity,
      "MeasureUnit": sum,
      "Price": product.quantity * product.list_price,
      "UserId": userid,
      "SessionId": subuserid,
      "PricePer": product.list_price,
      "descr": product.descr,
      "company_sy": Common.getWithExpiry("company_sy")
    }
    try {
      if (Common.getWithExpiry(userid + subuserid + Common.getWithExpiry("company_sy")) != undefined) {
        var getlistofcard = JSON.parse(Common.getWithExpiry(userid + subuserid + Common.getWithExpiry("company_sy")));
      }
    } catch (ed) { }
    if (getlistofcard != undefined && getlistofcard != null && getlistofcard.length > 0) {
      getlistofcard.push(cartModel);
    }
    else {
      getlistofcard = [];
      getlistofcard.push(cartModel);
    }
    Common.setWithExpiry(userid + subuserid + Common.getWithExpiry("company_sy"), JSON.stringify(getlistofcard))
    return this.http.post(environment.APIUrl + '/Product/InsertCart', cartModel);
    //return JSON.stringify(true);
  }

  addProductToCartPunchOut(UserID, SubuserID, product, sum) {
    let userId = UserID;
    if (product.list_price > 0) {

    }
    else {
      product.list_price = 0;
    }

    var cartModel = {
      "itemnumber": product.itemname,
      "Quantity": product.quantity,
      "MeasureUnit": sum,
      "Price": product.quantity * product.list_price,
      "UserId": userId == undefined ? 0 : userId,
      "SessionId": SubuserID == undefined ? this.getSessionId() : SubuserID,
      "PricePer": product.list_price,
      "descr": product.descr,
      "company_sy": Common.getWithExpiry("company_sy")
    }
    try {
      if (Common.getWithExpiry(userId + SubuserID + Common.getWithExpiry("company_sy")) != undefined) {
        var getlistofcard = JSON.parse(Common.getWithExpiry(userId + SubuserID + Common.getWithExpiry("company_sy")));
      }
    } catch (ed) { }
    if (getlistofcard != undefined && getlistofcard != null && getlistofcard.length > 0) {
      getlistofcard.push(cartModel);
    }
    else {
      getlistofcard = [];
      getlistofcard.push(cartModel);
    }
    Common.setWithExpiry(userId + SubuserID + Common.getWithExpiry("company_sy"), JSON.stringify(getlistofcard))
    return this.http.post(environment.APIUrl + '/Product/InsertCartPunchOut', cartModel);
    //return JSON.stringify(true);
  }

  updateCart(product) {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }
    var cartModel = {
      "itemnumber": product.itemname,
      "Quantity": product.Quantity,
      "MeasureUnit": product.MeasureUnit,
      "Price": product.Quantity * product.PricePer,
      "UserId": userid,
      "SessionId": subuserid,
      "PricePer": product.PricePer,
      "Note": product.Note,
      "descr": product.descr,
      "unitMeasure": product.unitMeasure,
      "company_sy": Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/UpdateCart', cartModel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  updateCartSession() {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }
    var umodel = {
      userId: userid,
      sessionId: subuserid,
      "company_sy": Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/UpdateCartSession', umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }




  getCartItemByUserID() {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }
    var umodel = {
      UserId: userid,
      SessionId: subuserid,
      company_sy: Common.getWithExpiry("company_sy")
    }
    //return this.http.post(environment.APIUrl + '/Product/GetCartItems', umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
    return this.http.post(environment.APIUrl + '/Product/GetCartItemsByUserId', umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
    // }
    // else {
    //   var u1model = {
    //     UserId: userId,
    //     SessionId: SubuserID,
    //     company_sy: Common.getWithExpiry("company_sy")
    //   }
    //   return this.http.post(environment.APIUrl + '/Product/GetCartItemsByUserId', u1model);
    // }
    //return Common.getWithExpiry(UserID+SubuserID+Common.getWithExpiry("company_sy"));
  }
  cartBroadCaster(product) {
    this.productAddedSource.next({ products: product });
  }

  cartBroadCaster1(totalCount) {
    this.productAddedSource1.next({ data: totalCount });
  }

  customerBroadCaster(customer) {
    this.customer.next(customer);
  }

  southernPunchOutBroadcast(res) {
    this.southernPunchOutSource.next({ result: res });
  }

  CreatesystaemUser(customer) {
    var umodel = {
      customer: customer,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/CreateSystemUser', umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  addtocartforsouthern(productlist) {    
    return this.http.post(environment.APIUrl + '/distoneapi/addtocartforsouthern', productlist, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  updateCartForSession() {
    let sessionId = this.getSessionId();
    var userid = Common.getWithExpiry("CustID");
    var subuserid = Common.getWithExpiry("UserID");
    var model = {
      SessionId: sessionId,
      UserId: userid,
      Subuserid: subuserid
    }
    return this.http.post(environment.APIUrl + '/Product/UpdateCartForSessionCart', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  cartBroadCasterLogin(UserID, SubuserID) {
    let userId = UserID;
    //let getusertype = UserType;
    // if(getusertype=="4"){
    //   userId=null;
    // }
    let sessionId = this.getSessionId();
    if (userId == null || userId == undefined) {
      this.productUpdatedLoginSource.next({ products: sessionId });
    }
    else {
      this.productUpdatedLoginSource.next({ products: userId, sessionId });
    }
  }

  deleteCartItem(itemNumber, um) {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }

    var delcart1 = {
      userId: userid,
      sessionId: subuserid,
      itemNumber: itemNumber,
      um: um,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/DeleteCartItemByUserId', delcart1, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });

  }
  deleteCartItemForSession(itemNumber, um, explicitSessionId?) {
    var userid = null;
    var subuserid = null;
    // Use the explicit session ID when provided (e.g. guest-to-login migration)
    // to ensure the delete targets the session that was active when items were loaded.
    userid = (explicitSessionId != null && explicitSessionId != undefined) ? explicitSessionId : this.getSessionId();
    subuserid = userid;
    var delcart1 = {
      userId: userid,
      sessionId: subuserid,
      itemNumber: itemNumber,
      um: um,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/DeleteCartItemByUserId', delcart1, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });

  }

  deleteCartItemPunchOut(UserID) {
    let userId = UserID;

    var delcart1 = {
      userId: userId,
      sessionId: "",
      itemNumber: "",
      um: "",
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/Product/DeleteCartItemPunchOut', delcart1, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getSessionId() {
    var getsessionid = Common.getWithExpiry("session");
    if (getsessionid != undefined && getsessionid != null && getsessionid!= '') {
      return getsessionid;
    }
    else {
      var id = Guid.newGuid();
      Common.setWithExpiry("session", id.toString());
      return id.toString();
    }


    // var nav = window.navigator;
    // var screen = window.screen;
    // var guid = nav.mimeTypes.length.toString();
    // guid += nav.userAgent.replace(/\D+/g, '');
    // guid += nav.plugins.length;
    // guid += screen.height || '';
    // guid += screen.width || '';
    // guid += screen.pixelDepth || '';
    // return guid;
    //return "";
  }


  getProductPrice(UserID, item, quantity) {
    var gmodel = {
      item: item,
      customer: UserID,
      quantity: quantity,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetPrice', gmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getProductImage(item) {
    var pmodel = {
      item: item,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetImage', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getBulkPrice(model) {    
    if(Common.getWithExpiry("UserType") == '5'){
      for(var i =0;i<model.length;i++){
        model[i].customer=this.dataService.Getconfigbykey("GuestUserID")
      }
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/BulkPrice', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }


  deleteCartByUserId() {
    var userid = null;
    var subuserid = null;
    if (Common.getWithExpiry("CustID") != undefined && Common.getWithExpiry("CustID") != null && Common.getWithExpiry("CustID") != '') {
      userid = Common.getWithExpiry("CustID");
      subuserid = Common.getWithExpiry("UserID");
    }
    else {
      userid = this.getSessionId();
      subuserid = this.getSessionId();
    }
    var umodel = {
      userId: userid,
      sessionId: subuserid,
    }
    return this.http.post(environment.APIUrl + '/Product/DeleteCartItem', umodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getShipRate(model) {
    return this.http.post(environment.APIUrl + '/Product/GetShipRate', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getShipRateUPS(model) {
    return this.http.post(environment.APIUrl + '/Product/CalculateShipRateForUPSOAuth', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getShipRateUPSLegacy(model) {
    return this.http.post(environment.APIUrl + '/Product/CalculateShipRateForUPS', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  GetErrordatabase() {
    return this.http.get('http://portal.distone.com/distonedemoApi/DistOneAPi/DataMigration');
  }
  getUPSShipRate(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/UPSReturnsMultipleRates', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetAllShipServicesRates(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetAllshipservicesRates', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getFedexShipRate(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/FedExReturnsRates', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  getUSPSShipRate(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/USPSReturnsMultipleRates', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
  GetCountryaddressCityCode(Country) {
    var rmodel = {
      Country: Country,
      company_sy: Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetCountryaddressCityCode', rmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }

  sendMissingProductEmail(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/SendMissingItemEmail', model, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) });
  }
}
